import React, { Component } from 'react';
import styles from './styles';
import { css } from 'aphrodite';

class Product extends Component {

    render() {
        const { data, linkTitle, style, lightVersion, dataLayer, selectedProduct, context } = this.props;
        // console.log(data);

        var isInt = context === 'int';
        var isQual = context === 'qual';
        var isProd = context === 'prod';
        var islocal = context === 'local';

        return (
            <div className={css(styles.product, style)}>
                {data.entity.fieldImage &&
                    <figure className={css(styles.figure)}>
                        <img className={css(styles.image)} src={data.entity.fieldImage.entity.fieldMediaImage.entity.url} alt=""/>
                    </figure>
                }
                <div className={css(styles.textWrapper)}>
                    <div className={css(styles.productTitleWrapper)}>
                        <h2 className={css(styles.title)}>{data.entity.entityLabel}</h2>

                        {linkTitle &&
                        <a className={css(
                            styles.link,
                            !data.entity.body && styles.noDescription,
                            isInt && styles.iconLinkInt,
                            isQual && styles.iconLinkQual,
                            isProd && styles.iconLinkProd,
                            islocal && styles.iconLinklocal,
                        )}
                        href={data.entity.fieldLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                                if (dataLayer !== null) {
                                    dataLayer.push({
                                        'event' : 'eventGA',
                                        'eventCategory': 'Grout calculator',
                                        'eventAction': 'product click',
                                        'eventLabel': selectedProduct.entity.entityLabel
                                    });
                                    // console.log(dataLayer);

                                }
                            }}
                            >
                        {linkTitle}
                        </a>
                        }
                    </div>
                    <div className={css(styles.descriptionWrapper)}>
                        {data.entity.body &&
                        <div className={css(styles.description)}
                        dangerouslySetInnerHTML={{__html: data.entity.body.value}}></div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

Product.defaultProps = {
    lightVersion: false
}

export default Product;